<template>
  <div>
    <modal
      name="add-vehicle-modal"
      :height="isMobile ? '100%' : '100%'"
      :width="isMobile ? '100%' : '60%'"
    >
      <div
        class="pt-3 pb-2 pr-4 pl-4 border-gray-100 dark:border-gray-500 dark:bg-gray-900 dark:text-gray-200"
      >
        <h4 class="inline-block w-11/12">LİSTEYE YENİ ARAÇ EKLE</h4>
        <button class="p-2 w-1/12" @click="$modal.hide('add-vehicle-modal')">
          <i class="fas fa-times"></i>
        </button>
      </div>
    <div class="h-auto py-4 mx-4 overflow-y-auto" style="max-height:calc(100vh - 60px)">
      <div class="flex">
        <div class="w-1/3">
            <diffInput
              type="numberLength"
              v-model="recomendedVehicleCount"
              :required="true"
              title="Araç Sayısı"
              :min="0"
              :valCount="calculateMaxVehicleCount()"
            />
        </div>
        <div class="w-1/3 ml-4">
          <diffInput
            type="select"
            :optList="[
              {
                id: 3,
                name: 'Hepsi',
              },
              {
                id: 1,
                name: 'Kiralık',
              },
              {
                id: 2,
                name: 'Özmal',
              },
            ]"
            minlength="1"
            :required="true"
            v-model="haveType"
            title="Araç Türü"
          />
        </div>
      </div>

      <!-- Ekipman Seçimi -->
      <div class="w-full mt-4">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          <i class="fas fa-tools mr-2"></i>
          Gerekli Ekipmanlar (Opsiyonel)
        </label>
        <button
          @click="$emit('open-equipment-modal')"
          type="button"
          class="w-full px-4 py-2 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg hover:border-blue-500 dark:hover:border-blue-400 transition-colors"
        >
          <i class="fas fa-plus mr-2"></i>
          {{ selectedEquipmentCategories && selectedEquipmentCategories.length > 0 ? 'Ekipman Seçimini Düzenle' : 'Ekipman Seç' }}
        </button>

        <!-- Seçili Ekipmanlar -->
        <div v-if="selectedEquipmentCategories.length > 0" class="mt-2 flex flex-wrap gap-2">
          <span
            v-for="cat in selectedEquipmentCategories"
            :key="cat"
            class="px-3 py-1 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded-full text-xs font-medium"
          >
            {{ getCategoryLabel(cat) }}
          </span>
        </div>
      </div>

      <bulkVehicle
        class=""
        :totalCount="recomendedVehicleCount"
        @removeVehicle="
          () => (recomendedVehicleCount = Number(recomendedVehicleCount) - 1)
        "
        @addVehicle="
          () => (recomendedVehicleCount = Number(recomendedVehicleCount) + 1)
        "
        @change="(r) => (vehicleList = r)"
        :recomendedCount="orderItem.recomendedCount"
        :deliveryDate="orderItem.complateDate"
        :center="calculateCenter()"
        :order="orderItem"
        :hiddenInsert="false"
        :rowId="rowId"
        network="collective"
        :isLoading="load"
        @update-total-count="handleTotalCount"
        :haveType="haveType"
        :requiredEquipmentCategories="selectedEquipmentCategories"
      />
      <div class="w-full mt-4 text-right">
        <asyncBtn
          icon="fas fa-check"
          :text="$t('general.saveButtonTitle')"
          :loadTitle="$t('general.saveButtonLoadTitle')"
          :loadState="load"
          class="w-full"
          @click="bulkSave()"
        />
      </div>
    </div>
    </modal>
  </div>
</template>

<script>
// import orderInput from "../../../../../components/devItem/orderInput.vue";

//Global Components
import diffInput from "@/components/general/diffInput.vue";
import asyncBtn from "@/components/general/asyncBtn.vue";
import bulkVehicle from "@/components/general/vehicleTable/vehicles.vue";

//Axios
import { bulkPlanning } from "@/networking/urlmanager";
import axios from "axios";
//Utilis
import { getLocationAll } from "@/utils/detailData";
export default {
  props: [
    "rowId",
    "orderNo",
    "capacity",
    "customerList",
    "customers",
    "orderItem",
    "selectedEquipmentCategories",
  ],
  components: {
    diffInput,
    asyncBtn,
    bulkVehicle,
  },
  data() {
    return {
      load: false,
      vehicleList: [],
      recomendedVehicleCount: "",
      bulkvehicleList: [],
      vehicleLoad: false,
      vehicle: "",
      dorseName: "",
      driverName: "",
      driverTC: "",
      longitude: "",
      latitude: "",
      haveType: 3,
    };
  },
  methods: {
    getCategoryLabel(category) {
      const labels = {
        'POMPA&HORTUM&DUSURUCU': 'Pompa & Hortum & Düşürücü',
        'GUVENLIK': 'Güvenlik Ekipmanı',
        'YEDEK_PARCA': 'Yedek Parça',
        'DIGER': 'Diğer'
      };
      return labels[category] || category;
    },

    calculateCenter() {
      return {
        lat:
          (this.orderItem.fillingLatitude + this.orderItem.deliveryLatitude) /
          2,
        lng:
          (this.orderItem.fillingLongitude + this.orderItem.deliveryLongitude) /
          2,
      };
    },
    calculateMaxVehicleCount() {
      let total =
        Number(this.orderItem.tonnage) - Number(this.orderItem.receivedTonnage);
      return total > 0 ? Math.ceil(total / 26) : 0;
    },
    handleTotalCount(val) {
      this.recomendedVehicleCount = val;
    },
    bulkSave() {
      const invalidVehicles = this.vehicleList?.filter((item) => {
        return !(item.driverName && item.driverTC);
      });

      if (invalidVehicles?.length > 0) {
        const vehicles = invalidVehicles.map((item) => item.vehicle).join(", ");
        this.swalBox(
          "warning",
          "Uyarı!",
          `Planlama yapılamaz !!! Aşağıdaki ${
            invalidVehicles.length > 1 ? "araçlar" : "araç"
          } için sürücü bilgisi veya TC kimlik bilgisi eksik:${vehicles} Plakalı ${
            invalidVehicles.length > 1 ? "araçlara" : "araca"
          } Lütfen sürücü atayınız veya mevcut sürücünün TC kimlik bilgisini giriniz.`
        );
        return;
      }

      this.load = true;
      axios
        .post(
          bulkPlanning.vehicleAdd,
          {
            vehicleList: this.vehicleList.map((item) => {
              return {
                vehicle: item.vehicle,
                plate: item.vehicle,
                dorse: item.dorse,
                driverName: item.driverName,
                isCustom: item.isCustom ?? 1,
                driverTC: item.driverTC,
                capacity: item.capacity,
                longitude: item.longitude,
                latitude: item.latitude,
                isWashing: item.recomendation?.isWashing || 3,
              };
            }),
            rowId: this.rowId,
            orderNo: this.orderNo,
            requiredEquipmentCategories: this.selectedEquipmentCategories,
            isEquipmentBased: this.selectedEquipmentCategories.length > 0,
          },
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        )
        .then(() => {
          this.swalBox(
            "success",
            this.$t("general.successTitle"),
            "",
            false,
            this.$t("general.OkayTitle")
          );
          this.$emit("refresh");
          this.$modal.hide("add-vehicle-modal");
        })
        .catch((err) => {
          this.errorBox(err.response);
        })
        .finally(() => {
          this.load = false;
        });
    },
  },
  computed: {
    isMobile() {
      return window.innerWidth < 768;
    },
    getFilterVehicle() {
      return this.vehicleList.map((item) => {
        return {
          name: item.vehicle,
          id: item.id,
          driverName: item.driverName,
          dorse: item.dorse,
          capacity: item.capacity,
          longitude: item.longitude,
          latitude: item.latitude,
        };
      });
    },
  },
  async created() {
    this.vehicleLoad = true;
    this.vehicleList = await getLocationAll(this.$store.state.userData.token);
    this.vehicleLoad = false;
  },
};
</script>

<style></style>